// @ts-nocheck
import { useRequestQuery } from '../../useQueryRequest';
import t from '../types';

/**
 * Retrieve A/R aging details for a specific customer.
 */
export function useARAgingDetails(customerId, query, props) {
  return useRequestQuery(
    [t.FINANCIAL_REPORT, t.AR_AGING_DETAILS, customerId, query],
    {
      method: 'get',
      url: `/financial_statements/receivable_aging_details/customer/${customerId}`,
      params: query,
    },
    {
      select: (res) => res.data,
      enabled: !!customerId,
      ...props,
    },
  );
}
